import cx from 'classnames'

import { Input } from 'almanac-ui/TextInputField/Input'
import { Button } from 'components/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ContentSourcePickerVariant } from './Types'
import { ExampleCard } from './ExampleCard'
import StepStyles from '../AddVoice/Step1.module.scss'
import Styles from './FromText.module.scss'
import { Heading } from 'almanac-ui/Heading/Heading'

export type FromTextProps = {
  examplesVisible?: boolean
  sampleText: string
  onChange: (sampleText: string) => void
  setExamplesVisible?: (value: boolean) => void
  variant?: ContentSourcePickerVariant
}

export const FromText: React.FC<React.PropsWithChildren<FromTextProps>> = ({
  examplesVisible,
  setExamplesVisible,
  sampleText,
  onChange,
  variant,
}) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.FromText}>
      <Heading level={4}>
        {variant === ContentSourcePickerVariant.CampaignImport
          ? 'Paste in sample text that we can analyze for your campaign'
          : 'Paste in text that we can analyze for your voice'}
      </Heading>
      <Input
        data-testid="voice-paste-in-text"
        value={sampleText}
        onChange={(e) => onChange(e.currentTarget.value)}
        size="xl"
        name="sampleText"
        isTextarea
        resizable={false}
        rows={isMobile ? 6 : 8}
        maxHeight={isMobile ? 120 : 184}
        id="source-text"
        maxLength={7000}
        placeholder={
          variant === ContentSourcePickerVariant.CampaignImport
            ? 'Paste in sample text that we can analyze for your campaign'
            : ''
        }
      />
      <div className={Styles.charCounter}>{sampleText.length}/7000</div>
      {variant === ContentSourcePickerVariant.BrandVoiceImport && (
        <>
          <div className={cx(Styles.showExamplesContainer, { [Styles.hidden]: !examplesVisible })}>
            <div className={StepStyles.sectionLabel}>Try some of the text examples below</div>
            <div className={Styles.examplesContainer}>
              <ExampleCard
                onSelect={onChange}
                text="Sherlock Holmes' voice was as sharp and precise as his deductive reasoning. Every word he uttered carried an air of intellectual confidence, with a hint of aloofness. It had a hypnotic quality that drew you into the intricate web of his investigations."
              />
              <ExampleCard
                onSelect={onChange}
                text="Huck's voice was a lyrical blend of Southern drawl and boyish innocence. It resonated with the rhythms of the Mississippi River, filled with curiosity and a dash of mischief. You could hear the freedom of the open river in every word he spoke."
              />
              {!isMobile && (
                <ExampleCard
                  onSelect={onChange}
                  text="Scarlett's voice was a symphony of Southern charm and determination. It carried the honeyed accents of Georgia, masking a fierce and indomitable spirit. Her words dripped with a mix of charm and ambition, leaving a lasting impression on all who heard her speak."
                />
              )}
            </div>
          </div>

          <div className={cx(Styles.showMeContainer, { [Styles.hidden]: examplesVisible })}>
            <Button size="md" variant="tertiary" onPress={() => setExamplesVisible?.(true)}>
              Show Me Examples
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
